class AdpMenuTogglerController {
  constructor() {
    this.name = 'adpMenuToggler';
    this.menuOpened = false;
  }
  toggleOpenState() {
    this.menuOpened = !this.menuOpened;
  }
}

export default AdpMenuTogglerController;



// WEBPACK FOOTER //
// ./src/app/components/adpMenuToggler/adpMenuToggler.controller.js